import Currency from "../money-format";

const customProductCard = (function () {
    /**
     * @type {Selectors}
     */
    const selectors = {
        addToCartButton: "[data-custom-add-to-cart-button]",
        dataVariantId: "data-variant-id",
        miniCartList: ".mini-cart-list",
        cartBubble: ".mcart-count",
        addedToCardModalOverlay: "#custom-added-to-card-modal-overlay",
        addedToCardModal: "#custom-added-to-card-modal",
        soldoutStatusAttr: "data-soldout-status",
        variantSelector: ".boost-pfs-filter-product-item-variant-selector",
        productCard : ".product_card_inner",
        ProductCardPrice : ".product_card_price", 
        ProductCardPriceV2 : ".product_card_price_v2", 
    };

    /**
     * @type {NotifyMeConfig}
     */
    let notifyMeConfig = {
        enabled: false,
        triggerSelector: null, 
        handleNotifyMe: null,
    };

    /**
     * Handles the "Add to Cart" button click
     * @param {Event} event - The click event
     */
    function handleAddToCartClick(event) {
        const button = event.target.closest(selectors.addToCartButton);

        if (!button) {
            return;
        }

        event.preventDefault();

        // Check sold-out status
        const isSoldOut = button.getAttribute(selectors.soldoutStatusAttr) === "true";
        if (isSoldOut) {
            console.warn("This product is sold out.");
            triggerNotifyMe(button);
            return;
        }

        setButtonLoading(button, true);
        const variantId = button.getAttribute(selectors.dataVariantId);

        if (!variantId) {
            console.warn("Variant ID is missing");
            setButtonLoading(button, false);
            return;
        }

        console.log(`Adding product ${variantId} to cart`);

        addToCart(variantId)
            .finally(() => {
                setButtonLoading(button, false);
            });
    }

    function handleVariantChange (event) {
        const select = event.target.closest(selectors.variantSelector);

        if (!select) {
            return;
        }
        const productCard = select.closest(selectors.productCard);
        const button = productCard ? productCard.querySelector(selectors.addToCartButton) : null;
        const priceContainer = productCard ? productCard.querySelector(selectors.ProductCardPrice) : null;
        const priceContainerV2 = productCard ? productCard.querySelector(selectors.ProductCardPriceV2) : null;

        const variantsData = JSON.parse(select.getAttribute("data-variants"));
        const selectedVariant = variantsData.find(variant => variant.id == select.value);
        console.log('selectedVariant', selectedVariant)
        

        if (!button) {
            return;
        }
        event.preventDefault();
 
        button.setAttribute("data-variant-id", select.value);
        button.setAttribute("data-soldout-status", !selectedVariant.available);


        if (priceContainer) {
            priceContainer.innerHTML = Currency.formatMoney((selectedVariant.price * 100));
        } 

        if (priceContainerV2) {
            priceContainerV2.innerHTML = Currency.formatMoney(selectedVariant.price);
        }





    }

    /**
     * Adds a product to the Shopify cart and updates the UI
     * @param {string} variantId - The ID of the variant to add
     */
    async function addToCart(variantId, openModal = true) {
        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1,
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to add product to cart", response);
            }

            const item = await response.json();
            console.log("Product added to cart:", item);
            
            const variantData = await fetchVariantData(variantId);
            let comparePrice = null;
            let isAvailable = false; 

            if (variantData) {
                comparePrice = getComparePrice(variantData);
                isAvailable = isVariantAvailable(variantData);
            } else {
                console.warn("Unable to fetch variant data. Continuing with cart update.");
            }

            const itemData = {
                title: item.product_title,
                image: item.image,
                quantity: item.quantity,
                price: Currency.formatMoney(item.price),
                comparePrice: comparePrice ? Currency.formatMoney(comparePrice) : null,
                selectedOption: item.variant_options[0],
                productId: item.product_id,
            }

            renderItemtoMinicart(item, comparePrice);
            updateBubble(1);
            if(openModal) {
                openAddedtoCartModal(itemData);
            }
        } catch (error) {
            console.error("Error adding product to cart:", error);
            alert("Unable to add product to cart. Please try again.");
        }
    }

    /**
     * Fetch variant data by ID.
     * @param {number} variantId - The ID of the variant to fetch.
     * @returns {Promise<Object|null>} - The variant data or null if an error occurs.
     */
    async function fetchVariantData(variantId) {
        if (!variantId || typeof variantId !== "number") {
            console.warn("Invalid variant ID provided.");
            return null;
        }

        try {
            const response = await fetch(`/variants/${variantId}.js`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch variant data for ID ${variantId}: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error(`Error fetching variant data for ID ${variantId}:`, error);
            return null;
        }
    }

    /**
     * Get the compare price for a variant.
     * @param {Object} variantData - The variant data object.
     * @returns {number|null} - The compare price or null if not available.
     */
    function getComparePrice(variantData) {
        if (!variantData) {
            console.warn("No variant data provided.");
            return null;
        }

        return variantData.compare_at_price || null;
    }

    /**
     * Check if a variant is available.
     * @param {Object} variantData - The variant data object.
     * @returns {boolean} - True if the variant is available, false otherwise.
     */
    function isVariantAvailable(variantData) {
        if (!variantData) {
            console.warn("No variant data provided.");
            return false;
        }

        return variantData.available || false;
    }

    /**
     * Renders a new item into the mini-cart UI
     * @param {Object} item - The added item object
     * @param {number|null} comparePrice - The compare price
     */
    function renderItemtoMinicart(item, comparePrice) {
        const minicartContainer = document.querySelector(selectors.miniCartList);

        if (!minicartContainer) {
            console.warn("Mini cart container not found");
            return;
        }

        const minicartItemHTML = `
      <div class="single-mcart-item">
        <div class="mcart-thumb">
          <a href="${item.url}" title="${item.title}">
            <img src="${item.image}" alt="${item.featured_image?.alt}">
          </a>
        </div>
        <div class="mcart-content">
          <p class="mcart-single-title"><a href="${item.url}">${item.title}</a></p>
          <p class="mcart-single-price">
            <span class="mcart-compare-price">${comparePrice ? Currency.formatMoney(comparePrice) : ""}</span>
            <span><b>${Currency.formatMoney(item.price)}</b></span>
          </p>
        </div>
      </div>
    `;
        minicartContainer.insertAdjacentHTML("beforeend", minicartItemHTML);
    }

    /**
     * Updates the cart bubble count
     * @param {number} quantity - The quantity to add
     */
    function updateBubble(quantity) {
        const cartBubble = document.querySelector(selectors.cartBubble);

        if (!cartBubble) {
            console.warn("Cart bubble not found");
            return;
        }

        const currentCount = parseInt(cartBubble.textContent) || 0;
        cartBubble.textContent = currentCount + quantity;
    }

    /**
     * Opens the added-to-cart modal with product details
     * @param {Object} itemData - The product details
     * @param {string} itemData.title - The product title
     * @param {string} itemData.image - The product image URL
     * @param {number} itemData.quantity - The quantity added
     * @param {string} itemData.price - The formatted price
     * @param {string|null} itemData.comparePrice - The formatted compare price
     * @param {string|null} itemData.selectedOption - The variant size
     */
    async function openAddedtoCartModal(itemData) {
        const modalOverlay = document.querySelector(selectors.addedToCardModalOverlay);
        const modalContent = document.querySelector(selectors.addedToCardModal);

        console.log("Opening added-to-cart modal with data:", itemData);

        if (!modalOverlay || !modalContent) {
            console.warn("Added-to-cart modal elements not found");
            return;
        }

        // Show modal
        modalOverlay.style.display = "block";
        modalContent.style.display = "block";

        const titleElement = modalContent.querySelector("[data-product-title]");
        const imageElement = modalContent.querySelector("[data-product-image]");
        const quantityElement = modalContent.querySelector("[data-product-quantity]");
        const priceElement = modalContent.querySelector("[data-product-price]");
        const comparePriceElement = modalContent.querySelector("[data-product-compare-price]");
        const sizeValueElement = modalContent?.querySelector("[data-product-size]");


        updateElement(titleElement, itemData.title);
        updateElement(imageElement, itemData.image, "src");
        updateElement(quantityElement, itemData.quantity);
        updateElement(priceElement, itemData.price);

        if (itemData.comparePrice) {
            updateElement(comparePriceElement, itemData.comparePrice);
            if (comparePriceElement) {
                comparePriceElement.style.display = "block";
            }
        } else {
            updateElement(comparePriceElement, "");
            if (comparePriceElement) {
                comparePriceElement.style.display = "none";
            }
        }

        if (itemData.selectedOption && itemData.selectedOption !== "Default Title") {
            updateElement(sizeValueElement, itemData.selectedOption);
            if (sizeValueElement) {
                sizeValueElement.parentElement.style.display = "flex";
            }
        } else {
            if (sizeValueElement) {
                sizeValueElement.parentElement.style.display = "none";
            }
        }

        document.querySelectorAll(".skeleton").forEach((skeleton) => {
            skeleton.classList.remove("skeleton");
        });

        const sliderContainer = modalContent.querySelector(".custom-product-recommendation-slider")
        const sliderContent = sliderContainer.querySelector(".custom-product-recommendation-slider__content");

        if (sliderContainer && sliderContent) {
            try {
                sliderContainer.setAttribute("loading", "true");
                sliderContent.innerHTML = "";
                const response = await fetch(
                    `${window.Shopify.routes.root}recommendations/products?product_id=${itemData.productId}&section_id=product-recommendations&intent=${window.atcButtonModalRecommendationIntent || "related"}`,
                );
    
                if (!response.ok) {
                throw new Error("Failed to fetch recommendations");
                }
    
                const html = await response.text();
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = html;
                const recommendationsSection = tempDiv.querySelector("#product-recommendations");
    
                if (recommendationsSection) {
                    sliderContent.innerHTML = recommendationsSection.innerHTML;

                    console.log("Recommendations injected:", sliderContent.innerHTML);
                    const slider = sliderContainer.querySelector(".product-recommendations-list");
    
                    // Initialize Slick slider after content injection
                    $(slider).slick({
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    infinite: true,
                                },
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                },
                            },
                        ],
                    });

                } else {
                    console.warn("Recommendations section not found in response.");
                }
            } catch (error) {
                console.error("Error fetching recommendations:", error);
            }
            finally {
                sliderContainer.removeAttribute("loading");
            }
        } else {
            console.warn("Recommendation slider container not found.");
        }

        // Attach addToCart method to ATC button in slider card
        const sliderATCButtons = sliderContainer.querySelectorAll(selectors.addToCartButton);
        sliderATCButtons.forEach(button => {
            button.addEventListener("click", (event) => {
            event.preventDefault();
            const variantId = button.getAttribute(selectors.dataVariantId);
            console.log("slider ATC button clicked", variantId);
            if (variantId) {
                setButtonLoading(button, true);
                addToCart(variantId, false)
                .then(() => {
                    const productCard = button.closest(".product_card");
                    const successMessage = productCard.querySelector(".product-add-to-cart-success-message");
                    if (successMessage) {
                        successMessage.style.display = "block";
                        setTimeout(() => {
                            successMessage.style.display = "none";
                        }, 2000);
                    }
                })
                .finally(() => {
                    setButtonLoading(button, false);
                });
            } else {
                console.warn("Variant ID is missing in slider card");
            }
            });
        });

    }

    /**
     * Sets or removes the loading state for the button
     * @param {HTMLElement} button - The button element
     * @param {boolean} isLoading - Whether to add or remove the loading state
     */
    function setButtonLoading(button, isLoading) {
        if (isLoading) {
            button.setAttribute("disabled", "true");
            button.style.cursor = "not-allowed";
            button.style.pointerEvents = "none";
            button.classList.add("loading");
        } else {
            button.removeAttribute("disabled");
            button.style.cursor = "pointer";
            button.style.pointerEvents = "auto";
            button.classList.remove("loading");
        }
    }

    /**
     * Updates the content or attribute of an element
     * @param {HTMLElement} element - The element to update
     * @param {string|number} value - The value to set
     * @param {string} [attribute] - The attribute to update (optional - defaults to textElement)
     */
    function updateElement(element, value, attribute = 'textElement') {
        if (!element) {
            console.warn(`Element not found for updating value: ${value}`);
            return;
        }

        if (attribute === "textElement") {
            element.textContent = value;
        }else {
            element.setAttribute(attribute, value);
        }
    }

    /**
     * Triggers the "Notify Me" functionality
     * @param {HTMLElement} button - The button element
     */
    function triggerNotifyMe(button) {
        if (!notifyMeConfig.enabled) {
            console.warn("Notify Me functionality is disabled.");
            return;
        }

        let triggerElement = null;
        if(button.nextElementSibling && button.nextElementSibling.matches(notifyMeConfig.triggerSelector)) {
            triggerElement = button.nextElementSibling;
        } else if(button.previousElementSibling && button.previousElementSibling.matches(notifyMeConfig.triggerSelector)) {
            triggerElement = button.previousElementSibling;
        }

        if (notifyMeConfig.handleNotifyMe) {
            // Use custom callback for Notify Me
            notifyMeConfig.handleNotifyMe(button);
        } else if (triggerElement) {
            // Default behavior: trigger the app-defined element
            triggerElement.click();
            console.log("Notify Me triggered via third-party app.");
        } else {
            console.warn("No Notify Me integration found.");
        }
    }

   

    return {
        /**
         * Initializes the custom product card component
         * @param {Object} options - The initialization options
         * @param {string} options.containerSelector - The CSS selector for the product container - required
         * @param {Object} [options.notifyMeConfig] - Configuration for Notify Me integration (optional)
         * @param {boolean} [options.notifyMeConfig.enabled=false] - Whether Notify Me is enabled
         * @param {string|null} [options.notifyMeConfig.triggerSelector=null] - Selector for the third-party trigger
         * @param {Function|null} [options.notifyMeConfig.handleNotifyMe=null] - Custom callback function for "Notify Me" logic
         */
        init: async function init({ containerSelector, notifyMeConfig: config }) {
            if (!containerSelector || typeof containerSelector !== "string") {
                throw new Error("containerSelector is required and must be a valid CSS selector string.");
            }

            console.log("customProductCard initialized", containerSelector);

            const productContainer = document.querySelector(containerSelector);

            if (!productContainer) {
                console.warn("Product container not found");
                return;
            }

            productContainer.addEventListener("click", handleAddToCartClick);
            productContainer.addEventListener("change", handleVariantChange);

            // Initialize Notify Me configuration
            if (config) {
                notifyMeConfig = { ...notifyMeConfig, ...config };
            }
        },
    };
})();

export default customProductCard;

/**
 * A collection of CSS selectors and attributes used throughout the component.
 * @typedef {Object} Selectors
 * @property {string} addToCartButton - Selector for the Add to Cart button.
 * @property {string} dataVariantId - Attribute name for the variant ID.
 * @property {string} miniCartList - Selector for the mini-cart container.
 * @property {string} cartBubble - Selector for the cart bubble element.
 * @property {string} addedToCardModalOverlay - Selector for the modal overlay.
 * @property {string} addedToCardModal - Selector for the modal container.
 */

/**
 * Configuration object for third-party integration
 * @typedef {Object} NotifyMeConfig
 * @property {boolean} enabled - Whether the "Notify Me" feature is enabled.
 * @property {string|null} triggerSelector - Selector for third-party trigger.
 * @property {Function|null} handleNotifyMe - Custom callback function for "Notify Me" logic.
 */
